import { createSignal, Show } from "solid-js";
import { useUserContext } from "./UserContext";

export default function UserSettings() {
  const [userStore, _setUserStore, userActions] = useUserContext() as any;
  const [editingName, setEditingName] = createSignal(false);
  const [newName, setNewName] = createSignal(userStore.username || '');
  const [isSaving, setIsSaving] = createSignal(false);

  const handleSaveName = () => {
    const name = newName().trim();
    if (!name) {
      alert('Please enter a valid name');
      return;
    }
    
    setIsSaving(true);
    userActions.updateStudentName(name);
    
    // Give some time for the update to complete
    setTimeout(() => {
      setEditingName(false);
      setIsSaving(false);
    }, 500);
  };

  const handleCancelEdit = () => {
    setNewName(userStore.username || '');
    setEditingName(false);
  };

  return (
    <div class="student-dashboard">
      <h2>Settings</h2>
      
      <div class="card mt-4">
        <div class="card-body">
          <h5 class="card-title">Your Information</h5>
          
          <div class="mb-3">
            <label class="form-label"><strong>Your Name:</strong></label>
            <Show when={!editingName()}>
              <div class="d-flex align-items-center">
                <span class="me-3">{userStore.username}</span>
                <button 
                  class="btn btn-sm btn-outline-primary"
                  onClick={() => setEditingName(true)}
                >
                  Edit
                </button>
              </div>
            </Show>
            
            <Show when={editingName()}>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control"
                  value={newName()}
                  onInput={(e) => setNewName(e.currentTarget.value)}
                  disabled={isSaving()}
                  placeholder="Enter your name"
                />
                <button 
                  class="btn btn-success"
                  onClick={handleSaveName}
                  disabled={isSaving()}
                >
                  {isSaving() ? 'Saving...' : 'Save'}
                </button>
                <button 
                  class="btn btn-secondary"
                  onClick={handleCancelEdit}
                  disabled={isSaving()}
                >
                  Cancel
                </button>
              </div>
            </Show>
          </div>

          <div class="mb-3">
            <label class="form-label"><strong>Client ID:</strong></label>
            <div>
              <code>{userStore.clientId}</code>
              <small class="text-muted d-block mt-1">
                This public ID is stored with a separate protected identity token in your browser.
              </small>
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label"><strong>User Type:</strong></label>
            <div>
              <span class="badge bg-info">External Student</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card mt-4">
        <div class="card-body">
          <h5 class="card-title">About External Student Access</h5>
          <p class="card-text">
            You're connected as an external student. This means:
          </p>
          <ul>
            <li>You don't need to log in via CAS authentication</li>
            <li>Your identity and its protected token are stored locally in your browser</li>
            <li>You can participate in quizzes using quiz codes</li>
            <li>Your name and responses are associated with your Client ID</li>
          </ul>
          <div class="alert alert-warning" role="alert">
            <strong>Note:</strong> Clearing browser data removes the protected identity token and creates a new student identity.
          </div>
        </div>
      </div>
      <div class="card mt-4">
        <div class="card-body">
        <button type="button" class="btn btn-primary"
            onClick={() => {
                localStorage.removeItem('jwt');
                location.reload();
            }}
        >Logout</button>
          <Show when={userStore.clientId} >
            <div class="alert alert-warning" role="alert">
              <strong>Note:</strong> A Client ID by itself cannot be used to recover or impersonate a student identity.
            </div>
          </Show>
        </div>
      </div>
    </div>
  );
}
